export enum HqoHeadersEnum {
  BRAND = 'hqo-app-brand',
  HQO_BUILDING_UUID = 'HqO-Building-UUID',
}

export const HQO_BRAND = 'HQO';

export enum OwnerType {
  BUILDING = 'BUILDING',
  BUILDING_COMPANY = 'BUILDING_COMPANY',
}

export enum Verticals {
  VISITOR_REGISTRATION = 'VISITOR_REGISTRATION',
  SERVICE_REQUEST = 'SERVICE_REQUEST',
  SERVICE_BOOKING = 'SERVICE_BOOKING',
  RESOURCE_BOOKING = 'RESOURCE_BOOKING',
}

export enum DeviceType {
  WEB = 'web',
  MOBILE = 'mobile',
}
